import React from 'react';
import clsx from 'clsx';

const tones = {
  cyan: 'bg-[var(--neon-cyan)]/8 text-[var(--neon-cyan)] border-[var(--neon-cyan)]/25 hover:bg-[var(--neon-cyan)]/15 hover:shadow-[0_0_12px_rgba(0,240,255,0.25)]',
  pink: 'bg-[var(--neon-pink)]/8 text-[var(--neon-pink)] border-[var(--neon-pink)]/25 hover:bg-[var(--neon-pink)]/15 hover:shadow-[0_0_12px_rgba(255,42,109,0.25)]',
  violet: 'bg-[var(--neon-violet)]/8 text-[var(--neon-violet)] border-[var(--neon-violet)]/25 hover:bg-[var(--neon-violet)]/15 hover:shadow-[0_0_12px_rgba(168,85,247,0.25)]',
  green: 'bg-[var(--neon-green)]/8 text-[var(--neon-green)] border-[var(--neon-green)]/25 hover:bg-[var(--neon-green)]/15 hover:shadow-[0_0_12px_rgba(57,255,20,0.25)]',
  amber: 'bg-[var(--neon-amber)]/8 text-[var(--neon-amber)] border-[var(--neon-amber)]/25 hover:bg-[var(--neon-amber)]/15 hover:shadow-[0_0_12px_rgba(245,158,11,0.25)]',
  muted: 'bg-white/5 text-[var(--text-secondary)] border-white/10 hover:bg-white/10 hover:text-[var(--text-primary)]',
};

export default function Tag({ children, tone = 'cyan', icon, className = '', ...rest }) {
  return (
    <span
      className={clsx(
        'inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[0.72rem] font-semibold tracking-wide border font-mono transition-all duration-200 cursor-default',
        tones[tone],
        className
      )}
      {...rest}
    >
      {icon && <span className="shrink-0 text-[0.85em]">{icon}</span>}
      <span>{children}</span>
    </span>
  );
}